import { ReactNode } from 'react';
import { FileQuestion, FolderOpen, Search } from 'lucide-react';
import { cn } from '@/lib/utils';

type EmptyStateVariant = 'default' | 'search' | 'folder';

interface EmptyStateProps {
  title: string;
  description?: string | undefined;
  icon?: ReactNode | undefined;
  variant?: EmptyStateVariant | undefined;
  action?: ReactNode | undefined;
  className?: string | undefined;
}

const variantIcons: Record<EmptyStateVariant, ReactNode> = {
  default: <FileQuestion className="h-12 w-12 text-muted-foreground" />,
  search: <Search className="h-12 w-12 text-muted-foreground" />,
  folder: <FolderOpen className="h-12 w-12 text-muted-foreground" />,
};

export function EmptyState({
  title,
  description,
  icon,
  variant = 'default',
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 text-center',
        className
      )}
    >
      <div className="mb-4">{icon ?? variantIcons[variant]}</div>
      <h3 className="text-lg font-semibold">{title}</h3>
      {description && (
        <p className="mt-1 text-sm text-muted-foreground max-w-sm">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
